import * as React from "react";
import { Button, Form, Modal } from "semantic-ui-react";

import { Input } from "@neworbit/simpleui-input";

import { isEmailDomainValid } from "../models";
import { toast } from "../../toasts";

interface Props {
    isAddAllowedEmailDomainModalOpen: boolean;
    onAllowedEmailDomainClose: () => void;
    onAllowedEmailDomainAdd: (domain: string) => void;
}

export const AddAllowableEmailDomainModal: React.FunctionComponent<Props> = (props: Props) => {

    const [newAllowedEmailDomain, setNewAllowedEmailDomain] = React.useState<string>(null);

    const onModalClose = () => {
        setNewAllowedEmailDomain(null);
        props.onAllowedEmailDomainClose();
    };

    const onAllowedEmailDomainAdd = () => {
        if (!isEmailDomainValid(newAllowedEmailDomain)) {
            toast.warning("Email domain format is not valid. Please use '@xxx.yyy");
            return;
        }

        props.onAllowedEmailDomainAdd(newAllowedEmailDomain);
        setNewAllowedEmailDomain(null);
    };

    return (
        <Modal open={props.isAddAllowedEmailDomainModalOpen} size="small">
            <Modal.Header>Add Allowable Email Domain</Modal.Header>
            <Modal.Content>
                <Form>
                    <Input.Text
                        required
                        label="Allowed Email Domain"
                        onChange={setNewAllowedEmailDomain}
                        value={newAllowedEmailDomain}
                    />
                </Form>
            </Modal.Content>
            <Modal.Actions>
                <Button content="Cancel" onClick={onModalClose} />
                <Button content="Add" onClick={onAllowedEmailDomainAdd} />
            </Modal.Actions>
        </Modal>
    );
};
